import { Box, Grid, Paper, Typography } from '@material-ui/core';
import styled from 'styled-components';

const mapTypeToCallButtonColor = (type?: string): string => {
  switch (type) {
    case 'numeros_secours':
      return '#0880BC';
    case 'numeros_assistance':
      return '#FFFFFF';
    default:
      return '#f5523c';
  }
};

export const SectionWrapper = styled(Paper)`
  padding: 16px;
`;
export const StyledSectionTitle = styled(Typography)`
  color: #04336b !important;
  font-size: 16px !important;
  font-weight: bold !important;
  letter-spacing: 0 !important;
  line-height: 19px !important;
`;
export const StyledItemTitle = styled(Typography)<{ type?: string }>`
  color: ${({ type }) =>
    `${type === 'numeros_assistance' ? 'white' : '#575e71'} !important`};
  font-size: 13px !important;
  font-weight: 500 !important;
  letter-spacing: 0 !important;
  line-height: 16px !important;
  margin: 0 8px !important;
`;
export const StyledItemActionText = styled(Typography)<{ type?: string }>`
  color: ${({ type }) => `${mapTypeToCallButtonColor(type)} !important`};
  font-size: 14px !important;
  font-weight: bold !important;
  letter-spacing: 0 !important;
  margin: 0 2px !important;
`;
export const StyledCallIcon = styled(Grid)<{ type?: string }>`
  color: ${({ type }) => `${mapTypeToCallButtonColor(type)} !important`};
  font-weight: bold !important;
  border: ${({ type }) =>
    `solid 1px ${mapTypeToCallButtonColor(type)} !important`};
  border-radius: 16px !important;
  padding: 4px;
  cursor: pointer;
`;

export const StyledItemWrapper = styled(Box)<{ icon?: string }>`
  border: 1px solid rgba(151, 151, 151, 0.24);
  border-radius: 10px;
  padding: 16px;
  background: ${({ icon }) =>
    icon ? `${mapTypeToSectionBgColor(icon)} !important` : ''};
`;

export const StyledLink = styled.a`
  text-decoration: none;
`;

const mapTypeToSectionBgColor = (icon?: string): string => {
  switch (icon) {
    case 'ServiceClientAuto':
      return 'linear-gradient(240.27deg, #1c89fd 0%, #1f2bc1 100%)';
    case 'ServiceClientMRH':
      return 'linear-gradient(218.03deg, #852D91 0%, #312A6C 100%)';
    case 'ServiceClientSante':
      return 'linear-gradient(218.03deg, #96C851 0%, #64AF3A 100%)';
    case 'ServiceClientASI':
      return 'linear-gradient(218.03deg, #51C87C 0%, #3AAF4E 100%)';
    default:
      return '#FFFFFF';
  }
};
